import { i18n, observable, observer, pr, React, theme, george } from "aaa";
import { NativeFlatButton } from "components/common/NativeFlatButton";
import { NativeIconButton } from "components/common/NativeIconButton";
import { themeColors, customColors } from "muiTheme";
import { BoldLabel } from "../../util/primitives";
// import flickerLib = require("./flickerLib");
import * as flickerLib from "./flickerLib";
import { ui } from "components/util/uiHelpers";

type IProps = {
    startCodeValue: string;
    clockSpeed: number;
    flickerCode: string;
} & i18n.InjectedIntlProps;

interface IState { }

@i18n.injectIntl
@observer
export default class Component extends React.Component<IProps, IState> {
    @observable private _showFlicker = true;

    componentDidMount() {
        // Set reasonable initial flicker size
        // flickerLib.resizeFlicker(2);
    }

    /**
     * When _showFlicker is false, we only hide the Flicker code, DO NOT disable the rendering
     * completely. If you do so then the Flicker will reset on rerender and the size and speed will
     * be reset!
     */
    renderFlicker() {
        const __ = i18n.bindStr(this.props.intl!);

        const flickerHtml = flickerLib.showFlickerCode(this.props.startCodeValue, this.props.flickerCode, this.props.clockSpeed);

        const iconButtonStyle = {
            width: 50,
            height: 50,
            marginLeft: 10,
            marginRight: 10,
        };

        const iconStyle = {
            width: 36,
            height: 36,
            color: "grey"
        };

        return (
            <div className="theme-paper-color" style={{ display: this._showFlicker ? "block" : "none" }}>
                <div style={{ display: "flex", justifyContent: "center", marginBottom: 4 }}>
                    <NativeIconButton
                        style={iconButtonStyle}
                        onClick={() => {
                            flickerLib.resizeFlicker(-0.1);
                        }}
                    >
                        <pr.IconZoomOut style={iconStyle} />
                    </NativeIconButton>

                    <NativeIconButton
                        style={iconButtonStyle}
                        onClick={() => {
                            flickerLib.resizeFlicker(0.1);
                        }}
                    >
                        <pr.IconZoomIn style={iconStyle} />
                    </NativeIconButton>

                    <NativeIconButton
                        style={iconButtonStyle}
                        onClick={() => {
                            flickerLib.flickerSpeedSlower();
                        }}
                    >
                        <pr.IconFastRewind style={iconStyle} />
                    </NativeIconButton>

                    <NativeIconButton
                        style={iconButtonStyle}
                        onClick={() => {
                            flickerLib.flickerSpeedFaster();
                        }}
                    >
                        <pr.IconFastForward style={iconStyle} />
                    </NativeIconButton>
                </div>
                <div
                    style={{ display: "inline-block", overflowX: "hidden", maxWidth: theme.MAX_APP_WIDTH }}
                    dangerouslySetInnerHTML={{
                        __html: flickerHtml
                    }}
                /><br />

                <NativeFlatButton
                    onClick={() => this._showFlicker = false}
                >
                    <BoldLabel style={{ color: customColors.georgeGradient2 }}>
                        {__("cardtan.enterDataManually")}
                    </BoldLabel>
                </NativeFlatButton>
            </div>
        );
    }

    renderSeparator() {
        return <pr.LightSeparatorLine />;
    }

    /**
     * For now, draw only the start code
     */
    renderManualData() {
        const __ = i18n.bindStr(this.props.intl!);

        return (
            <div
                style={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "column",
                    alignItems: "center"
                }}
            >
                {this.renderSeparator()}
                <div
                    style={{
                        display: "flex",
                        width: "90%",
                        textAlign: "left"
                    }}
                >
                    <george.LabeledValue label={__("cardtan.startcode")} value={this.props.startCodeValue} hideSeparator />
                </div>

                {this.renderSeparator()}

                <NativeFlatButton
                    onClick={() => this._showFlicker = true}
                >
                    <BoldLabel style={{ color: customColors.georgeGradient2 }}>
                        {__("cardtan.backToFlicker")}
                    </BoldLabel>
                </NativeFlatButton>

                {this.renderHelpText()}
            </div >
        );
    }

    renderHelpText = () => {
        return (
            <pr.P_14_CONTENT
                style={{
                    margin: "0px 20px",
                    paddingBottom: 20,
                    textAlign: "left",
                }}
            >
                <i18n.FormattedHTMLMessage id="cardtan.helpText" />
            </pr.P_14_CONTENT>
        );
    }

    render() {
        return (
            <div style={{ textAlign: "center" }} >
                {this.renderFlicker()}
                {this._showFlicker ? null : this.renderManualData()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/signing/views/Flicker.tsx